import axios from 'axios';
import TomSelect from 'tom-select';

declare let booking_object: any;

export default class roomTimeSlot{

    public control: TomSelect | null = null; // Property to hold the TomSelect instance

    /**
     * Initializes the TomSelect control once.
     * It sets up an empty, disabled control ready to be loaded with data.
     */
    initialize(selector: string) {

        const element = document.querySelector(selector) as HTMLSelectElement;

        if (!element) {
            console.error(`Time slot selector "${selector}" not found.`);
            return;
        }

        if((element as any).tomselect){

            this.control = (element as any).tomselect;
            return;

        }

        const settings = {
            plugins: ['dropdown_input'],
            valueField: 'slot_start_time',
            labelField: 'slot_start_time',
            searchField: ['slot_start_time'],
            preload: true,
            render: {
                option: (item, escape) => `<span class="block w-full fluid-text-xs">${escape(item.slot_start_time)}</span>`,
                item: (item, escape) => `<span>${escape(item.slot_start_time)}</span>`,
            }
        };

        this.control = new TomSelect(element, settings);
        this.control.disable(); // Start as disabled

    }

    /**
     * Loads or reloads data into the existing TomSelect control.
     * Returns a promise that resolves with the selected value.
     */
    load(book_calendar: any, room_id: string): Promise<string | null> {

        // By making the Promise callback 'async', we can use 'await' inside it.
        return new Promise(async (resolve, reject) => {

            if(!this.control){

                return reject(new Error("TomSelect for time slots is not initialized. Call initialize() first."));

            }

            // The code flow is now linear, so TypeScript understands this.control is not null.
            this.control.clear();
            this.control.clearOptions();
            this.control.enable();

            try{

                const post_data = { 'room_id': room_id, 'date': book_calendar.getDate('y/mm/dd') };
                const queryString = new URLSearchParams(post_data).toString();

                // We await the result of the axios call directly.
                const response = await axios.post(booking_object.rest_urls.get_room_time_slots, queryString);

                if(response.data.data && Array.isArray(response.data.data) && response.data.data.length > 0){

                    this.control.addOptions(response.data.data);
                    const first_value = response.data.data[0].slot_start_time;
                    this.control.setValue(first_value);
                    resolve(first_value);

                }else{
                    
                    const placeholder = { slot_start_time: booking_object.general_message.no_time };
                    this.control.addOption(placeholder);
                    this.control.setValue(placeholder.slot_start_time);
                    this.control.disable();
                    resolve(null);

                }

            }catch (error){

                // Any error from the 'await' call will be caught here.
                if(this.control){
                    
                    this.control.disable();

                }

                reject(error);

            }

        });
        
    }

    /**
     * Populates the TomSelect control with data.
     * @param timeSlotsData 
     * @returns 
     */
    populate(timeSlotsData: any[]): string | null {

        if(!this.control){

            return null;

        }

        this.control.clear();
        this.control.clearOptions();
        this.control.enable();

        if(timeSlotsData && timeSlotsData.length > 0){
            
            this.control.addOptions(timeSlotsData);
            const first_value = timeSlotsData[0].slot_start_time;
            this.control.setValue(first_value);
            return first_value;

        }else{
            
            const placeholder = { slot_start_time: booking_object.general_message.no_time };
            this.control.addOption(placeholder);
            this.control.setValue(placeholder.slot_start_time);
            this.control.disable();
            return null;

        }

    }

}